import { Progress } from '@ahafood/ui/components/progress';
import { cn } from '@ahm/common-helpers';
import { Star } from 'lucide-react';
import React from 'react';

import type { Store } from '@/api/ahafood/get-store-fn';

type RatingDistributionProps = {
  store: Store;
  className?: string;
  progressBarClassName?: string;
  averageRatingClassName?: string;
  starsClassName?: string;
  totalRatingsClassName?: string;
};

export function RatingDistribution({
  store,
  className,
  progressBarClassName,
  averageRatingClassName,
  starsClassName,
  totalRatingsClassName,
}: RatingDistributionProps) {
  const totalRatings = Object.values(store.rating.detail).reduce(
    (sum, val) => sum + val,
    0
  );

  return (
    <div className={cn('flex items-start gap-4 mb-4 w-full', className)}>
      <div className="flex-1 space-y-1">
        {[5, 4, 3, 2, 1].map((star) => {
          const count =
            store.rating.detail[
              star.toString() as keyof typeof store.rating.detail
            ] || 0;
          const percentage =
            store.rating.total > 0 ? (count / totalRatings) * 100 : 0;

          return (
            <div key={star} className="flex items-center gap-2 text-xs">
              <div className="flex items-center gap-1 w-8">
                <span className="text-neutral-90 font-medium w-3">{star}</span>
                <Star className="size-3 fill-yellow-40 text-yellow-40" />
              </div>
              <div className="flex-1">
                <Progress
                  value={percentage}
                  className={cn('h-1.5 bg-neutral-20', progressBarClassName)}
                />
              </div>
              {/* <span className="w-6 text-right text-muted-foreground">
                {count}
              </span> */}
            </div>
          );
        })}
      </div>
      {/* Rating Distribution */}

      <div className="flex flex-col items-center">
        <div className={cn('text-3xl font-bold', averageRatingClassName)}>
          {store.rating.average.toFixed(1)}
        </div>
        <div className={cn('flex items-center gap-1.5 mt-1', starsClassName)}>
          {[1, 2, 3, 4, 5].map((star) => (
            <Star
              key={star}
              className={cn(
                'size-4',
                star <= Math.floor(store.rating.average)
                  ? 'fill-yellow-40 text-yellow-40'
                  : 'fill-neutral-30 text-neutral-30'
              )}
            />
          ))}
        </div>
        <div
          className={cn(
            'text-sm text-muted-foreground mt-1',
            totalRatingsClassName
          )}
        >
          {totalRatings} đánh giá
        </div>
      </div>
    </div>
  );
}
